export default "__VITE_ASSET__D$x_osSl__"